import LocalStorage from 'utils/LocalStorage';

const removeLocalStorage = () => {
  const removeItem = (item) => {
    if (LocalStorage.getItem(item) !== null) {
      LocalStorage.removeItem(item);
    }
  };
  /*
  AE: keywordList, activeFilters are no longer used but it's necessary to keep here to backward compatibility
  */
  /*AE: We do in this way instead of LocalStorage.clear in order to keep some values from other libraries */
  removeItem('keywordList');
  removeItem('activeFilters');
  removeItem('listsIds');
  removeItem('clientsIds');
  removeItem('seeUnreadFilter');
  removeItem('contentFilters');
  removeItem('notShowAgainMarkAllPopup');
  removeItem('lastSenderEmailAddress');
  removeItem('firstTimeContactsAdded');
  removeItem('sectionsView');
  removeItem('firstBriefingGenerating');
  removeItem('billTrackerTrackedItems');
};

export default removeLocalStorage;
